// extracted by mini-css-extract-plugin
export var container = "RZ4pA";
export var description = "yLd9j";
export var icon = "LjVAg";
export var iconWrapper = "_0-vsX";
export var textSection = "U0U6Q";
export var title = "lAVTb";